export default __webpack_public_path__ + "static/media/hero.6b68d025.png";